import C from '../../../constants';

export function appDisplay(state = {}, action) {
    switch (action.type) {
        case C.SET_APPLICATION_KEY:
            return {
                ...state,
                applicationKey: action.payload
            };

        case C.INCREMENT_APPLICATION_KEY:
            return {
                ...state,
                applicationKey: state.applicationKey + 1
            };

        case C.DECREMENT_APPLICATION_KEY:
            return {
                ...state,
                applicationKey: state.applicationKey - 1
            };

        case C.SET_APPLICATION_SHOW_ADD_HISTORY:
            return {
                ...state,
                showAddHistory: action.payload
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/tenant/reducers/appDisplayReducer.js